import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import {Alert, Button, ConfirmModal, StrokeIcon} from "./ui";

const CancelFileButton = ({fileId, status, isAdmin, price_status, price}) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleCancel = async () => {
        try {
            setLoading(true);
            await axiosInstance.put(`/files/${fileId}/cancel`);
            setLoading(false);
            if (!isAdmin) {
                navigate("/my-files");
            } else {
                navigate("/admin/all-files");
            }
        } catch (error) {
            setLoading(false);
            if (error.response.status === 400) {
                setErrorMessage(error.response.data.message);
                return;
            }
            setErrorMessage("Something went wrong");
        } finally {
            setShowModal(false);
        }
    };

    return (
        <div className="space-y-3">
            {errorMessage && <Alert tone="error">{errorMessage}</Alert>}

            {isAdmin ||
            (price_status &&
                price_status === "UNPAID" &&
                status !== "CANCELED" &&
                status !== "REFUNDED") ? (
                <Button
                    variant="danger"
                    onClick={() => setShowModal(true)}
                    disabled={loading}
                    className="w-full"
                >
                    <StrokeIcon className="h-5 w-5">
                        <circle cx="12" cy="12" r="9"/>
                        <path d="m15 9-6 6M9 9l6 6"/>
                    </StrokeIcon>
                    Cancel this file
                </Button>
            ) : (
                !isAdmin &&
                (status === "CANCELED" ? (
                    <Alert tone="error">Your file is already canceled.</Alert>
                ) : status === "REFUNDED" ? (
                    <Alert tone="warning">
                        Your file is already refunded — <b>CRS: {price}</b>
                    </Alert>
                ) : null)
            )}

            {showModal && (
                <ConfirmModal
                    title="Cancel file?"
                    message="Are you sure you want to cancel this file? Any credits already charged are refunded automatically."
                    confirmLabel="Yes, cancel it"
                    cancelLabel="Keep it"
                    busy={loading}
                    onConfirm={handleCancel}
                    onCancel={() => setShowModal(false)}
                />
            )}
        </div>
    );
};

export default CancelFileButton;
